import React, { useEffect, useState, useCallback } from "react";
import useAuth from "../../hooks/useAuth";
import { getEmpresaAdmin } from "../../api/RoleInfo";
import { makeSafeGetRequest, makeSafePostRequest } from "../utils/Requests";
import { ToastContainer } from "react-toastify";
import { notifyPendingNotify, popNotification } from "../utils/Notify";

function CreateUsersRuta() {
  const { auth } = useAuth();

  // State for user role and permissions
  const [role, setRole] = useState();

  // State for empresa/company data
  const [empresasList, setEmpresasList] = useState();
  const [idEmpresa, setIdEmpresa] = useState();
  const [nombreEmpresa, setNombreEmpresa] = useState();

  // State for acopio and ruta selections
  const [acopios, setAcopios] = useState();
  const [selectedAcopio, setSelectedAcopio] = useState();
  const [rutas, setRutas] = useState();
  const [selectedRuta, setSelectedRuta] = useState();
  const [selectedRutaNombre, setSelectedRutaNombre] = useState();
  const [productores, setProductores] = useState();
  const [results, setResults] = useState();

  // User role determination
  const determineRole = () => {
    console.log("rol del usuario" + auth.roles[0]);
    setRole(auth.roles[0]);
  };

  // Get company data for admin users
  const getEmpresa = async () => {
    try {
      console.log("obteniendo empresa");
      const response = await getEmpresaAdmin(auth);
      setIdEmpresa(response?.empresa?.id);
      setNombreEmpresa(response?.empresa.nombre);
    } catch (error) {
      console.log("Error al obtener empresa:", error);
    }
  };

  // Get list of companies for superadmin
  const getEmpresasList = async () => {
    if (role === "superadmin") {
      try {
        const response = await makeSafeGetRequest("empresas", auth.accessToken);
        if (response && response.status === 200) {
          console.log("empresas obtenidas", response.data.data);
          setEmpresasList(response?.data.data);
        } else {
          console.log("error al obtener las empresas");
          setEmpresasList(null);
        }
      } catch (error) {
        console.log("Error al obtener empresas:", error);
        setEmpresasList(null);
      }
    }
  };

  // Get acopios for selected company
  const getAcopios = async () => {
    console.log("OBTENIENDO ACOPIOS DE LA EMPRESA" + idEmpresa);
    if (idEmpresa) {
      try {
        const response = await makeSafeGetRequest(
          `acopiosempresa/${idEmpresa}`,
          auth.accessToken
        );
        if (response && response.status === 200) {
          console.log("acopios obtenidos", response.data.data);
          setAcopios(response?.data);
        } else {
          console.log("error al obtener los acopios");
          setAcopios(null);
        }
      } catch (error) {
        console.log("error al obtener los acopios:", error);
        setAcopios(null);
      }
    } else {
      console.log("ID DE EMPRESA NO ESTABLECIDO, NO SE OBTIENEN ACOPIOS");
    }
  };

  // Get rutas for selected acopio
  const getRutas = async () => {
    if (selectedAcopio) {
      try {
        const response = await makeSafeGetRequest(
          `rutasacopio/${selectedAcopio}`,
          auth.accessToken
        );
        if (response && response.status === 200) {
          console.log("rutas obtenidas", response.data.data);
          setRutas(response?.data);
        } else {
          console.log("error al obtener las rutas");
          setRutas(null);
        }
      } catch (error) {
        console.log("error al obtener las rutas:", error);
        setRutas(null);
      }
    }
  };

  // Get productores for selected ruta
  const getProductores = useCallback(async () => {
    if (selectedRuta) {
      console.log("🔍 Fetching productores for ruta:", selectedRuta);
      try {
        // Try the main endpoint first
        const response = await makeSafeGetRequest(
          `productoresrutausuario/${selectedRuta}`,
          auth.accessToken
        );
        console.log("📡 API Response:", {
          status: response?.status,
          data: response?.data,
          url: `productoresruta/${selectedRuta}`,
        });

        if (response && response.status === 200) {
          // Handle different possible data structures
          const productoresData = response.data?.data || response.data;
          console.log("✅ Productores data to set:", productoresData);
          console.log(
            "📊 Number of productores:",
            productoresData?.length || 0
          );
          setProductores(productoresData);
        } else {
          console.log(
            "❌ Error response:",
            response?.status,
            response?.statusText
          );
          setProductores(null);
        }
      } catch (error) {
        console.log("💥 Exception al obtener los productores:", error);
        setProductores(null);
      }
    } else {
      console.log("⚠️ No selectedRuta provided");
    }
  }, [selectedRuta, auth.accessToken]);

  // Handle user creation
  const handleCreateUsers = async () => {
    if (!selectedRuta) {
      alert("Por favor seleccione una ruta");
      return;
    }
    const notification=notifyPendingNotify();
    // TODO: Implement user creation logic
    try {
      const response =await makeSafePostRequest("usersforproductoresruta/"+selectedRuta,{},auth.accessToken)
      if (response && response.status === 200) {
        console.log("Usuarios creados exitosamente");
        popNotification(notification, "success", response.data.exitosos+" Usuarios creados exitosamente "+response.data.existentes+" Usuarios  existentes, "+response.data.fallidos+" Usuarios fallidos");
        setResults(response.data);
       }else{
        console.log("Error al crear usuarios");
        popNotification(notification, "error", "Error al crear usuarios");
      }
    } catch (error) {
      
    }
    console.log("Creating users for ruta:", selectedRuta);
  };
  // Effects
  useEffect(() => {
    determineRole();
    console.log(role);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (role === "administrador") {
      getEmpresa();
    } else if (role === "superadmin") {
      setIdEmpresa(null);
      getEmpresasList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  useEffect(() => {
    console.log("empresa seleccionada: " + idEmpresa);
    if (idEmpresa) {
      getAcopios();
      // Reset downstream selections when company changes
      setSelectedAcopio(null);
      setSelectedRuta(null);
      setRutas(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEmpresa]);

  useEffect(() => {
    console.log("acopio seleccionado: " + selectedAcopio);
    if (selectedAcopio) {
      getRutas();
      // Reset ruta selection when acopio changes
      setSelectedRuta(null);
    } else {
      setRutas(null);
      setSelectedRuta(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAcopio]);

  useEffect(() => {
    console.log(
      "🎯 useEffect triggered - ruta seleccionada:",
      selectedRuta,
      typeof selectedRuta
    );
    console.log("📋 Available rutas:", rutas);
    if (rutas && rutas.length > 0) {
      console.log("🔍 First ruta structure:", rutas[0]);
      console.log("🔍 First ruta ID:", rutas[0]?.id, typeof rutas[0]?.id);
    }
    if (selectedRuta) {
      console.log("🚀 Calling getProductores...");
      getProductores();
      // Set the route name for display - try different comparison methods
      const selectedRoute = rutas?.find((r) => {
        console.log(
          "🔄 Comparing:",
          r.id,
          "(type:",
          typeof r.id,
          ") === ",
          selectedRuta,
          "(type:",
          typeof selectedRuta,
          ")"
        );
        return (
          r.id === selectedRuta ||
          r.id === selectedRuta ||
          r.id === parseInt(selectedRuta) ||
          r.id === selectedRuta.toString()
        );
      });
      console.log("🏷️ Selected route found:", selectedRoute);
      setSelectedRutaNombre(selectedRoute?.nombre || `Ruta ${selectedRuta}`);
    } else {
      console.log("🧹 Clearing productores data");
      setProductores(null);
      setSelectedRutaNombre("");
    }
  }, [selectedRuta, rutas, getProductores]);
  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-6">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold ">
              Crear Usuarios para Productores de Ruta
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              Empresa:{" "}
              <span className="font-medium">
                {nombreEmpresa || "No seleccionada"}
              </span>
            </p>
          </div>
          {/* Form Content */}
          <div className="space-y-6">
            {(role === "superadmin" || role === "administrador") && (
              <div className="space-y-4">
                {/* Company Selection */}
                <div className=" w-full max-w-xs">
                  <label className="label">
                    <span className="label-text font-medium">
                      Seleccione la Empresa:
                    </span>
                  </label>
                  <select
                    className="select select-bordered w-full"
                    onChange={(e) => {
                      setIdEmpresa(e.target.value);
                      setNombreEmpresa(
                        e.target.options[e.target.selectedIndex].text
                      );
                    }}
                    value={idEmpresa || ""}
                  >
                    <option value="">Seleccione una empresa</option>
                    {empresasList &&
                      empresasList.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.attributes.nombre}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Acopio Selection */}
                {idEmpresa && (
                  <div className=" w-full max-w-xs">
                    <label className="label">
                      <span className="label-text font-medium">Acopio:</span>
                    </label>
                    <select
                      className="select select-bordered w-full"
                      onChange={(e) => setSelectedAcopio(e.target.value)}
                      value={selectedAcopio || ""}
                    >
                      <option value="">Seleccione un acopio</option>
                      {acopios &&
                        acopios.map((acopio) => (
                          <option key={acopio.id} value={acopio.id}>
                            {acopio.nombre}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {/* Ruta Selection */}
                {selectedAcopio && (
                  <div className="w-full max-w-xs">
                    <label className="label">
                      <span className="label-text font-medium">Ruta:</span>
                    </label>
                    <select
                      className="select select-bordered w-full"
                      onChange={(e) => {
                        setSelectedRuta(e.target.value);
                        const selectedRoute = rutas?.find(
                          (r) => r.id === e.target.value
                        );
                        setSelectedRutaNombre(selectedRoute?.nombre || "");
                      }}
                      value={selectedRuta || ""}
                    >
                      <option value="">Seleccione una ruta</option>
                      {rutas &&
                        rutas.map((ruta) => (
                          <option key={ruta.id} value={ruta.id}>
                            {ruta.nombre}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {selectedRuta && productores && Array.isArray(productores) && productores.length > 0 && (
                  <div className="card bg-base-100 shadow-md mt-4">
                    <div className="card-body">
                      <h3 className="card-title">Ruta: {selectedRutaNombre}</h3>
                      <div className="overflow-x-auto">
                        <table className="table table-compact">
                          <thead>
                            <tr>
                              <th>Productores sin cuenta</th>
                              <th>Productores con cuenta</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="font-bold text-error">
                                {productores.filter(p => p.users_permissions_user === null).length}
                              </td>
                              <td className="font-bold text-success">
                                {productores.filter(p => p.users_permissions_user !== null).length}
                              </td>
                              <td className="font-bold">
                                {productores.length}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {/* Action Button */}
                {selectedRuta && (
                  <div className="pt-4">
                    <label 
                      className="btn btn-primary" 
                      htmlFor="modal-create-users"
                    >
                      Crear usuarios para ruta
                    </label>
                  </div>
                )}
              </div>
            )}
            
            {results && (
              <div className="mt-6 p-4 border rounded-lg bg-green-50">
                <h2 className="text-lg font-semibold mb-2">Resultados de la creación de usuarios:</h2>
                <ul className="list-disc list-inside">
                  <li>Usuarios creados exitosamente: {results.exitosos}</li>
                  <li>Usuarios existentes: {results.existentes}</li>
                  <li>Usuarios fallidos: {results.fallidos}</li>
                </ul>
                {results.fallidos > 0 && results.fallidosList && (
                  <div className="mt-4">
                    <h3 className="font-semibold">Detalles de fallidos:</h3>
                    <ul className="list-disc list-inside">
                      {results.fallidosList.map((fallido, index) => (
                        <li key={index}>{fallido}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>  
            )}

            {/* Loading state */}
            {!role && (
              <div className="flex justify-center py-8">
                <div className="loading loading-spinner loading-lg"></div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Modal de confirmación */}
      <input type="checkbox" id="modal-create-users" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">Confirmar creación de usuarios</h3>
          <p className="py-4">
            ¿Está seguro que desea crear usuarios para todos los productores sin cuenta en la ruta seleccionada?
          </p>
          <div className="space-y-2 text-sm">
            <p><span className="font-bold">Ruta:</span> {selectedRutaNombre}</p>
            <p><span className="font-bold">Productores sin cuenta:</span> {productores && Array.isArray(productores) ? productores.filter(p => p.users_permissions_user === null).length : 0}</p>
          </div>
          <div className="modal-action">
            <label
              htmlFor="modal-create-users"
              className="btn btn-primary"
              onClick={handleCreateUsers}
            >
              Sí, crear usuarios
            </label>
            <label htmlFor="modal-create-users" className="btn">
              Cancelar
            </label>
          </div>
        </div>
      </div>
      
      <ToastContainer
              position="bottom-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
    </div>
  );
}

export default CreateUsersRuta;
